/** Common saga — reserved for cross-cutting async work. */
export function* commonSaga() {
  // no-op watchers for now
}
